import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { MonitoringOverviewComponent } from './pages/monitoring-overview/monitoring-overview.component';
import { Login } from './pages/login/login.component';
import { Authguard } from './services/authguard.service';

export const routes: Routes = [
    { path: 'login', component: Login },
    { path: '', component: HomeComponent, canActivate: [Authguard], pathMatch: 'full' },
];
